export default "__VITE_ASSET__C$IQFv2r__"